export class LocationIds {
    segment!: string;
    locationId!: string;
  }